import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Moon, Sun, Globe, Menu, X } from 'lucide-react';
import { t } from '../utils/translations';

const Header = ({ isDarkMode, toggleDarkMode, language, toggleLanguage }) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  const navItems = [
    { path: '/', label: t('common.home', language) },
    { path: '/about', label: t('common.about', language) },
    { path: '/lab', label: t('common.lab', language) }
  ];

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <header className="header">
      <div className="container">
        <div className="header-content">
          {/* 로고 */}
          <Link to="/" className="logo">
            <span className="logo-text">{t('header.companyName', language)}</span>
            <span className="logo-subtitle">
              {t('header.companySubtitle', language)}
            </span>
          </Link>

          {/* 데스크톱 네비게이션 */}
          <nav className="nav-desktop">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`nav-link ${location.pathname === item.path ? 'active' : ''}`}
              >
                {item.label}
              </Link>
            ))}
          </nav>

          {/* 컨트롤 버튼들 */}
          <div className="header-controls">
            <button
              onClick={toggleLanguage}
              className="control-btn"
              title={t('common.changeLanguage', language)}
            >
              <Globe size={20} />
              <span className="language-text">{language.toUpperCase()}</span>
            </button>
            
            <button
              onClick={toggleDarkMode}
              className="control-btn"
              title={isDarkMode ? t('common.lightMode', language) : t('common.darkMode', language)}
            >
              {isDarkMode ? <Sun size={20} /> : <Moon size={20} />}
            </button>

            {/* 모바일 메뉴 버튼 */}
            <button
              onClick={toggleMobileMenu}
              className="mobile-menu-btn"
              title={t('common.menu', language)}
            >
              {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>

        {/* 모바일 네비게이션 */}
        {isMobileMenuOpen && (
          <nav className="nav-mobile">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`nav-link ${location.pathname === item.path ? 'active' : ''}`}
                onClick={() => setIsMobileMenuOpen(false)}
              >
                {item.label}
              </Link>
            ))}
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;
